import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, GuardResult, RedirectCommand, Router } from '@angular/router';
import { StaffAuthService } from '../staff-auth.service';
import { StaffAccountsService } from '../api-services/staff-accounts.service';

async function canActivate(): Promise<GuardResult>{
  return await new Promise<GuardResult>(resolve => {
    const staffAuthService = inject(StaffAuthService);
    const staffAccountsService = inject(StaffAccountsService);
    const router = inject(Router);
  
    const staffLoginToken = staffAuthService.GetAuthToken();
    if (staffLoginToken !== null){
      staffAccountsService.GetCurrentAccount().subscribe({
        next: apiResponse => {
          staffAuthService.CurrentStaffAccount.set(apiResponse.Data!);
          return resolve(true);
        },
        error: () => {
          return resolve(new RedirectCommand(router.createUrlTree(["/staff-login"])));
        }
      });
    } else {
      return resolve(new RedirectCommand(router.createUrlTree(["/staff-login"])));
    }
  });
}

export const staffAuthChildrenGuard: CanActivateChildFn = async () => {
  return await canActivate();
};

export const staffAuthGuard: CanActivateFn = async () => {
  return await canActivate();
};

